import React from 'react';
import { formatCurrency, getSeatLimit } from './SuperAdminShared';

const SuperAdminPackages = ({ packages, onCreatePackage, onEditPackage, onArchivePackage }) => (
  <section className="mt-6 space-y-6">
    <div className="flex flex-col gap-4 rounded-3xl border border-white/70 bg-white/90 px-5 py-5 shadow-sm sm:flex-row sm:items-center sm:justify-between">
      <div>
        <div className="text-xs uppercase tracking-[0.22em] text-cyan-700">Package Builder</div>
        <h3 className="mt-2 text-2xl font-semibold">Plans with simple role limits</h3>
        <p className="mt-1 max-w-2xl text-sm text-slate-500">
          Set admin seats and worker seats. The total user limit is calculated automatically, so there is no separate max users field to manage.
        </p>
      </div>
      <button
        type="button"
        onClick={onCreatePackage}
        className="rounded-2xl bg-slate-950 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-slate-300 transition hover:-translate-y-0.5 hover:bg-slate-800"
      >
        Create Package
      </button>
    </div>

    <div className="grid grid-cols-1 gap-5 xl:grid-cols-3">
      {packages.map((pkg) => (
        <div key={pkg.id} className="overflow-hidden rounded-3xl border border-white/70 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-xl">
          <div className="h-2 bg-gradient-to-r from-cyan-400 via-sky-500 to-slate-900" />
          <div className="p-5">
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="inline-flex rounded-full bg-cyan-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-cyan-700">{pkg.status || 'active'}</div>
                <h4 className="mt-2 text-2xl font-semibold">{pkg.package_name}</h4>
              </div>
              <div className="flex gap-3 text-sm">
                <button type="button" onClick={() => onEditPackage(pkg)} className="text-cyan-700 hover:text-cyan-900">Edit</button>
                <button type="button" onClick={() => onArchivePackage(pkg)} className="text-rose-700 hover:text-rose-900">Archive</button>
              </div>
            </div>
            <div className="mt-4 text-3xl font-semibold">{formatCurrency(pkg.price)}</div>
            <div className="mt-1 text-sm text-slate-500">{pkg.duration_months} months access</div>
            <div className="mt-5 grid grid-cols-3 gap-3 text-sm">
              <div className="rounded-2xl bg-slate-50 p-3">
                <div className="text-slate-500">Total seats</div>
                <div className="mt-1 font-semibold">{getSeatLimit(pkg)}</div>
              </div>
              <div className="rounded-2xl bg-slate-50 p-3">
                <div className="text-slate-500">Admins</div>
                <div className="mt-1 font-semibold">{pkg.max_admins}</div>
              </div>
              <div className="rounded-2xl bg-slate-50 p-3">
                <div className="text-slate-500">Workers</div>
                <div className="mt-1 font-semibold">{pkg.max_workers}</div>
              </div>
            </div>
            <div className="mt-5 space-y-2 text-sm text-slate-600">
              {(pkg.feature_list || []).map((feature) => (
                <div key={feature} className="flex gap-2">
                  <span className="text-cyan-600">+</span>
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default SuperAdminPackages;